import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import { Redirect, NavLink,Link} from 'react-router-dom';
import Header from '../Header';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';



class SelectLeave extends Component {
    constructor(props)
    {
        super(props);
        this.renderLeavesAvailable = this.renderLeavesAvailable.bind(this);
        this.onClickApply = this.onClickApply.bind(this);
        this.state = {
           

        }
    }

    onClickApply(leave)
    {
        this.props.updateSelectedLeave(leave);
        
        
    }

    

    


    renderLeavesAvailable()
        {
            const _this = this;
            if(!this.props.apiError)
            {
                console.log("No api error");
                console.log("leaves ", this.props.leavesAvailable);

                if(this.props.leavesAvailable.length > 0)
                {
                    let leaveListing = _this.props.leavesAvailable.map(leave => {
                            return (<tr>
                                    <td>{leave.title}</td>
                                    <td>{leave.days}</td>
                                    <td><button type="submit" disabled={leave.days < 1}  onClick={_this.onClickApply.bind(_this, leave)} onTap={_this.onClickApply.bind(_this, leave)} className="btn btn-primary btn-round">Apply<div className="ripple-container"></div></button></td>
                               

                            </tr>);
                            });

                    return(
                    <div className="block-centered col-lg-10 col-md-10">
                        <h4 className="center-align">Select the Leave you would like to apply for</h4>
                        
                        <table width = "100%">
                            <thead>
                                <tr>
                                    <td style ={{fontWeight:"bold"}}>LEAVE TYPE</td>
                                    <td style ={{fontWeight:"bold"}}>AVAILABLE DAYS</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {leaveListing}
                            </tbody>
                        </table>
                    </div>);
                }
                else
                {
                    return(
                    <div>
                        <p>No Leave Available for you to apply.</p>   
                    </div>);
                }
                
            }
            else{
                return (
                    <div>
                    <h3>Error</h3>
                    <p> {_this.props.apiResponse}</p>   
                </div>);
            }
        }

    


  render() {

    console.log("selected leave ", this.props.selectedLeave);

    if(this.props.selectedLeave != null)
    {
      return(<Redirect to = "/staff_ui/leave/specifydays"/>);
    }

    console.log("render leaves available");

    return (
        
        <div className="col-lg-12 col-md-12 full-width">
            {this.renderLeavesAvailable()}
        </div>
    );
  }
}

export default SelectLeave;
